import { create } from 'zustand';

interface ActionPulseState {
  /** Key = action name. */
  pulses: Record<string, number>;
  /**
   * Triggers a re-render of hooks subscribed to `action` — used by HUD icons
   * to replay their "bump" animation.
   */
  pulse: (action: string) => void;
}

/**
 * Propagates "action pressed" events to UI components (HUD, popups). The
 * counter is intentionally simple: components react via `useActionPulse(action)`
 * and each increment triggers a local re-render.
 */
export const useActionPulseStore = create<ActionPulseState>((set) => ({
  pulses: {},
  pulse: (action) =>
    set((state) => ({
      pulses: { ...state.pulses, [action]: (state.pulses[action] ?? 0) + 1 },
    })),
}));

/** Non-React helper to pulse from outside a component. */
export function pulseAction(action: string): void {
  useActionPulseStore.getState().pulse(action);
}

/** Returns the current counter for `action` (0 if never pulsed). */
export function useActionPulse(action: string): number {
  return useActionPulseStore((s) => s.pulses[action] ?? 0);
}
